module.exports = __webpack_public_path__ + "img/全网媒体触达-中层.dd35cc81.png";